// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Ofs9","label":"Section_label__1FltW","contentWrap":"Section_contentWrap__1ANhF","footer":"Section_footer__2iNAg","footerInner":"Section_footerInner__1S5W0"};